import React from "react";
import { StyleSheet, View, Platform } from "react-native";
import { FAB } from "react-native-paper";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { COLORS } from "../../constants";

/**
 * CustomFab Component
 *
 * A floating action button with customizable positioning and properly centered icon.
 */
const CustomFab = ({
  onFabClick,
  FontAwesomeIcon,
  icon = faPlus,
  color = COLORS.textLight,
  backgroundColor = COLORS.textDark,
  size = 24,
  bottomOffset = null,
  topOffset = null,
  rightOffset = 16,
  leftOffset = null,
  accessibilityLabel = "",
}) => {
  return (
    <FAB
      style={[
        styles.fab,
        {
          bottom: bottomOffset !== null ? bottomOffset : "auto",
          top: topOffset !== null ? topOffset : "auto",
          right: rightOffset !== null ? rightOffset : "auto",
          left: leftOffset !== null ? leftOffset : "auto",
          backgroundColor: backgroundColor,
        },
      ]}
      color={color}
      accessibilityLabel={accessibilityLabel}
      icon={() => (
        <View style={styles.iconContainer}>
          <FontAwesomeIcon icon={icon} size={size} color={color} />
        </View>
      )}
      onPress={onFabClick}
      mode="contained"
    />
  );
};

const styles = StyleSheet.create({
  fab: {
    position: "absolute",
    width: 56,
    height: 56,
    borderRadius: 28,
    justifyContent: "center",
    alignItems: "center",
    elevation: Platform.OS === "android" ? 5 : 0,
    shadowColor: Platform.OS === "ios" ? "#000" : "transparent",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 3,
  },
  iconContainer: {
    justifyContent: "center",
    alignItems: "center",
    width: 24,
    height: 24,
  },
});

export default CustomFab;
